import { FC, useId } from "react";
import { QESRadioButton } from "@app/shared/qes-standards/forms/RadioButton";
import { OutreachDataFilterType } from "@app/network-outreach/export/enumerations";

interface SelectDataFilterProps {
  testIdPrefix: string; // Used for the testId
  onDataSelectionChange: (dataSelection: OutreachDataFilterType) => void;
  dataSelection: OutreachDataFilterType;
}

const SelectDataFilter: FC<SelectDataFilterProps> = (props: SelectDataFilterProps) => {
  const testId = `outreach-export-${props.testIdPrefix}__data-select`;
  const radioGroupName = useId();

  return (
    <>
      <p className="lead mb0 demibold">Outreach Data Filter</p>
      <div className="form-group row">
        <div className="col-lg-12">
          <p>Please select the practitioner and service location data to include:</p>
          <div>
            <QESRadioButton
              label="All"
              name={radioGroupName}
              testId={testId + "-" + OutreachDataFilterType.All}
              value={OutreachDataFilterType.All}
              checked={props.dataSelection === OutreachDataFilterType.All}
              onChange={() => { props.onDataSelectionChange(OutreachDataFilterType.All); }}
            />
          </div>
          <div>
            <QESRadioButton
              label="Inactive"
              name={radioGroupName}
              testId={testId + "-" + OutreachDataFilterType.Inactive}
              value={OutreachDataFilterType.Inactive}
              checked={props.dataSelection === OutreachDataFilterType.Inactive}
              onChange={() => { props.onDataSelectionChange(OutreachDataFilterType.Inactive); }}
            />
          </div>
          <div>
            <QESRadioButton
              label="Exclusions"
              name={radioGroupName}
              testId={testId + "-" + OutreachDataFilterType.Exclusions}
              value={OutreachDataFilterType.Exclusions}
              checked={props.dataSelection === OutreachDataFilterType.Exclusions}
              onChange={() => { props.onDataSelectionChange(OutreachDataFilterType.Exclusions); }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default SelectDataFilter;
